import { ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { CompanyBranding } from '../components/CompanyBranding';
import { CompanyPageSkeleton } from '../components/CompanyPageSkeleton';
import { CompanySettingsForm } from '../components/CompanySettingsForm';
import { useCompanySettings } from '../hooks/use-company-settings';
import { CompanyTabs } from '../public/CompanyTabs';
import { sectionTrail } from '../../../shared/components/section-trail';

export function CompanySettingsPage() {
  const { state, saveError, saving, save, savingLogo, uploadLogo, removeLogo } = useCompanySettings();

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('company')}
        title="Company"
        description="The company this deployment serves: its particulars, locale, location and branding."
      />
      <CompanyTabs active="details" />
      {state.status === 'error' && (
        <EmptyState
          icon={ShieldAlert}
          title="Couldn't load company settings"
          description="Something went wrong loading the company settings. Try reloading the page."
        />
      )}
      {state.status === 'loading' && <CompanyPageSkeleton />}
      {state.status === 'loaded' && (
        <CompanySettingsForm
          settings={state.settings}
          error={saveError}
          submitting={saving}
          onSave={save}
          aside={<CompanyBranding settings={state.settings} savingLogo={savingLogo} onUploadLogo={uploadLogo} onRemoveLogo={removeLogo} />}
        />
      )}
    </>
  );
}
